import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { teachersView, studentsView, teacherTabs, studentTabs, coursesView, coursesTab, myGroupsView, ScoreGroupsPanel, StudentAttendance, StudentAttendanceList } = Views;

const AulaRouter = {
  path: "/aula",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "teachers",
      name: "Teachers",
      component: teachersView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "students",
      name: "Students",
      component: studentsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "teacher-detail/:Id?",
      name: "TeachersDetails",
      component: teacherTabs,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "student-detail/:Id?",
      name: "StudentsDetails",
      component: studentTabs,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "courses",
      name: "Courses",
      component: coursesView,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "courses-detail/:Id?",
      name: "CoursesDetails",
      component: coursesTab,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "my-groups",
      name: "MyGroups",
      component: myGroupsView,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "my-groups-detail/:Id?",
      name: "MyGroupsDetails",
      component: ScoreGroupsPanel,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "student-attendance",
      name: "StudentAttendance",
      component: StudentAttendance,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "student-attendance-list/:Id?",
      name: "StudentAttendanceList",
      component: StudentAttendanceList,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },


  ],
};

export default AulaRouter;
